import * as React from 'react';

import { useSelector } from 'react-redux';
import { selectEstimationTarget, selectFormFields, selectIsNewbuilding } from '../../../selectors';
import { EMyHomeEstimationTargets } from '../../../types/estimationTarget';

/**
 * Функция для определения доступности кнопки
 * Слушает изменения полей в форме
 * Для каждого типа недвижимости
 * */
export const useButtonDisabled = (): boolean => {
  const estimationTarget = useSelector(selectEstimationTarget);
  const isNewbuilding = useSelector(selectIsNewbuilding);

  const { address, flatNumber, roomsCount, area, houseArea, landArea } = useSelector(selectFormFields);

  const [isButtonDisabled, setButtonDisabled] = React.useState(true);

  // При смене типа недвижимости дизейблим кнопку
  React.useEffect(() => {
    return () => setButtonDisabled(true);
  }, [estimationTarget]);

  React.useEffect(() => {
    if (isNewbuilding) {
      const isNewbuildingFormDisabled = !address.length || !area || !roomsCount;

      setButtonDisabled(isNewbuildingFormDisabled);

      return;
    }

    switch (estimationTarget) {
      case EMyHomeEstimationTargets.house: {
        const isHouseFormDisabled = !address.length || !houseArea || !landArea;

        setButtonDisabled(isHouseFormDisabled);

        return;
      }
      case EMyHomeEstimationTargets.land: {
        const isLandFormDisabled = !address.length || !landArea;

        setButtonDisabled(isLandFormDisabled);

        return;
      }
      default: {
        const isFlatFormDisabled = !address.length || !area || !flatNumber || !roomsCount;

        setButtonDisabled(isFlatFormDisabled);

        return;
      }
    }
  }, [address, flatNumber, roomsCount, area, houseArea, landArea, estimationTarget, isNewbuilding]);

  return isButtonDisabled;
};
